/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getServices: (params) => {
    return axios.get(API_ENDPOINTS.GET_SERVICES, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getServiceswithfaremodel: () =>{
    return axios.get(API_ENDPOINTS.GET_SERVICES_WITH_FARE_MODEL, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addservices: (data) => {
  return axios.post(API_ENDPOINTS.ADD_SERVICES, data, {
    headers: { isAuthRequired: true, "Content-Type": "application/json" },
  });
},

};